export interface Agreement {
  agreementId: number;
  heading: null | string;
  agreementText: string;
  isRequired: boolean;
  isReadOnly: boolean;
  value: boolean;
}

export enum AGREEMENT_TYPE {
  MARKETING = 'marketing',
  STATEMENTS = 'statements',
}

export interface AgreementsApi {
  [AGREEMENT_TYPE.MARKETING]: Agreement[];
  [AGREEMENT_TYPE.STATEMENTS]: Agreement[];
}
